<template>
  <div class="square-image-wrapper">
    <a v-if="url" :target="target" :href='url'>
      <img :src="imageSource" class="img-fluid" :class="className" :alt="$t(alternateText)" :style="styles"/>
    </a>
    <img v-else :src="imageSource" class="img-fluid" :class="className" :alt="$t(alternateText)" :style="styles"/>
    <p v-if="shouldShowAltText" class="image-alt-text">{{ $t(alternateText) }}</p>
  </div>
</template>

<script>
export default {
  name: "square-image",
  props: {
    target:String,
    imageSource: {
      type: String,
      default: "@/assets/logo.png"
    },
    alternateText: {
      type: String,
      default: "Sample Image"
    },
    url:{
      type:String
    },
    styles:{
      type: Object,
      default:()=>{}
    },
    className: String
  },
  computed: {
    shouldShowAltText() {
      // Only show alt text for images that contain embedded text
      // These are the translation keys for images with text content
      const imagesWithText = [
        'productBackSideAltText',
        'reclaimImageAltText'
      ];
      return imagesWithText.includes(this.alternateText);
    }
  }
};
</script>

<style scoped>
.square-image-wrapper {
  display: inline-block;
  width: 100%;
}

img[data-field-type="square-image"] {
  object-fit: cover
}

.image-alt-text {
  font-size: 8px;
  line-height: 1.2;
  color: #000000;
  margin: 5px 0 0 0;
  padding: 0;
  text-align: center;
  opacity: 0.7;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
